// Denial screen shown when a guest's read of a link-shared scheduler is denied
// (allowLinkSharing off). Presentational only — the SchedulerPage decides when
// to render this. No redirect loop: the guest stays on the URL and is offered a
// real sign-in path.
export default function NotPublicScreen({ onSignIn }) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center text-slate-700 dark:text-slate-200">
      <p className="text-sm font-semibold uppercase tracking-[0.2em] text-slate-500 dark:text-slate-400">
        This poll isn&apos;t public
      </p>
      <p className="max-w-sm text-lg font-semibold text-slate-800 dark:text-slate-100">
        You need to be signed in to view this session poll.
      </p>
      <button
        type="button"
        onClick={onSignIn}
        className="min-h-[44px] rounded-full bg-brand-primary px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-brand-primary/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2"
      >
        Sign in
      </button>
    </div>
  );
}
